/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Accept_PlanInputs */

const en_us2_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept plan`)
};

const pt_br2_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar plano`)
};

const es_419_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar plan`)
};

const pt_pt2_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar plano`)
};

const fr_fr2_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter le programme`)
};

const de_de2_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan übernehmen`)
};

const it_it2_draft_accept_plan = /** @type {(inputs: Draft_Accept_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta scheda`)
};

/**
* | output |
* | --- |
* | "Accept plan" |
*
* @param {Draft_Accept_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_accept_plan = /** @type {((inputs?: Draft_Accept_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Accept_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_accept_plan(inputs)
	if (locale === "es-419") return es_419_draft_accept_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_accept_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_accept_plan(inputs)
	if (locale === "de-DE") return de_de2_draft_accept_plan(inputs)
	if (locale === "it-IT") return it_it2_draft_accept_plan(inputs)
	return en_us2_draft_accept_plan(inputs)
});
export { draft_accept_plan as "draft.accept_plan" }